import { fetcher } from 'src/config/request';
import { ContentListEndpoints } from './endpoints';
export const ContentListService = {
    async getModules(params) {
        return (await fetcher.get(ContentListEndpoints.getModules(), { params })).data.sort((moduleA, moduleB) => moduleA.order - moduleB.order);
    },
    async getPages(moduleId) {
        const response = await fetcher.get(ContentListEndpoints.getPages(moduleId));
        return response.data
            .map((page) => ({ ...page, type: page.type.toLowerCase() }))
            .sort((pageA, pageB) => pageA.pageOrder - pageB.pageOrder);
    }
};
